import styled from 'styled-components';

const MobileContent = styled.div`
  display: none;
  flex-grow: 1;
  font-size: 16px;
  line-height: 22px;
  margin-top: 60px;
  padding: 40px 15px 20px;
  white-space: pre-line;
`;

export const CLASS_NAME_MOBILE_CONTENT = 'mobile-content';

export const isMobileContentDisplayed = () => {
  const mobileContentElement = document.getElementsByClassName(
    CLASS_NAME_MOBILE_CONTENT,
  )[0];
  return (
    mobileContentElement &&
    window.getComputedStyle(mobileContentElement).display != 'none'
  );
};

export default MobileContent;
